import { MethodInstall } from "../../utils";
import Upload from "./src/index.js";

export default MethodInstall(Upload, "Upload");
